let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("18Ekc")).then(() => parcelRequire('28dfS'));